import { isMobile } from '@/device/deviceConfig'
import { openExternal } from '@/components/openExternal'
import { DOWNLOAD_APP_URL } from '@/header/downloadAppUrl'

/** A phone goes straight to the app store link; a computer goes to the desktop app's download page. */
export function openGetApp(deeplinkUrl: string): void {
    openExternal(isMobile() ? deeplinkUrl : DOWNLOAD_APP_URL)
}
